import { productionUnitFields } from '../productionUnit';

export const formAccountOverviewFilter = {
  BALANCE_DATE: 'balanceDate',
  ACCOUNT_ID: 'accountId',
  ACCOUNT_IDS: 'accountIds',
  IDS: 'ids',
  BALANCE_START_DATE: 'balanceStartTime',
  BALANCE_END_DATE: 'balanceEndTime',
  FUEL_TYPE: 'fuelType',
  GAS_TYPE: 'gasType',
  CLEANING_TECHNOLOGY_TYPE: productionUnitFields.TECHNOLOGY_TYPE,
  HYDROGEN_TECHNOLOGY_TYPE: productionUnitFields.HYDROGEN_TECHNOLOGY_TYPE,
  HYDROGEN_FUEL_TYPE: 'hydrogenFuelType',
  VALID_UNTIL: 'goValidUntil',
  PRODUCTION_UNIT_ID: 'productionUnitId',
  GROUP_BY_EXPIRATION: 'groupByExpiration',
  GROUP_BY_FUEL_TYPE: 'groupByFuelType',
  GROUP_BY_TECHNOLOGY: 'groupByTechnology',
  GROUP_BY_HYDROGEN_TECHNOLOGY: 'groupByHydrogenTechnology',
  GROUP_BY_HYDROGEN_FUEL_TYPE: 'groupByHydrogenFuelType',
  GROUP_BY_PRODUCTION_UNIT: 'groupByProductionUnit',
  SUSTAINABLE_BIOFUEL: 'sustainableBiofuel',
  SELECTED_ROWS: 'selectedRows',
};
